
function installTableConfigTool() {
  try {
    // if (process.env.NODE_ENV === 'development') {
    //   return import(/* webpackChunkName: "public_table_config_plugin" */ '@/bss-common/components/table-config-plugin/index')
    // }
    // 表格配置组件远程包加载
    new Promise(window.__ERP_REMOTE_IMPORT__('bss_common/BssTableConfigTool')).then()
  } catch (e) {
    console.error('[table-config-plugin] 加载失败', e)
  }
}

setTimeout(() => {
  installTableConfigTool()
}, 1000)



// WEBPACK FOOTER //
// ./src/layout/layout/setup/table-config-plugin.js